var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Icon } from "../UI";

const getExtension = (filename) => filename.substr(filename.lastIndexOf('.') + 1);

const acceptedThumbnailExtensions = ['png', 'gif', 'jpg'];

export class Thumbnail extends Component {
  render() {
    const { file, alt } = this.props;

    const extension = getExtension(file);
    let thumbnail;

    if (acceptedThumbnailExtensions.includes(extension)) {
      thumbnail = /*#__PURE__*/_jsx("img", { src: file, alt: alt });
    }

    if (extension === 'pdf') {
      thumbnail = /*#__PURE__*/
      _jsx("span", { "no-translate": true }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "file-pdf" }), " pdf");


    }

    return /*#__PURE__*/_jsx("div", { className: "thumbnail" }, void 0, thumbnail);
  }
}

Thumbnail.defaultProps = {
  alt: ''
};






export default Thumbnail;